import moment from 'moment';

module.exports = (startDate, endDate) => {
    const startDateToFormat = startDate ? moment(startDate) : moment();
    const formattedStartDate = startDateToFormat.format('YYYYMMDD');
    let apiDate = '';
    if (endDate) {
        const endDateToFormat = moment(endDate);
        const formattedEndDate = endDateToFormat.format('YYYYMMDD');
        if(formattedEndDate === formattedStartDate) {
            apiDate = formattedEndDate;
        } else if(formattedEndDate > formattedStartDate) {
            apiDate = `${formattedStartDate}-${formattedEndDate}`
        } else {
            apiDate = `${formattedEndDate}-${formattedStartDate}`
        }
    } else {
        apiDate = `${formattedStartDate}`;
    }

    return apiDate;
};



// WEBPACK FOOTER //
// ./app/lib/format/apiDateFormatter.js